class PriceQuantity extends HTMLElement {
  constructor() {
    super();
    this.priceElement = this.querySelector('.price-item');
    this.dataPrice = this.getAttribute('data-price');
    this.dataFormat = this.getAttribute('data-format');

    if(!window.priceQuantity){
      window.priceQuantity = 1;
    }

    document.querySelector('input[name="quantity"]')?.addEventListener('change', (e) => {
      priceQuantity = parseInt(e.target.value);
      this.updatePrice();
    });

    this.updatePrice();
  }

  updatePrice() {
    let price = this.calculatePrice(priceQuantity, this.dataPrice * 0.01);
    let formattedPrice = this.formatPrice(price);
    this.querySelector('.price-item').innerHTML = formattedPrice;

    const container = document.querySelector(".cart-drawer__product-container");

    if (container) {
      const productForm = container.querySelector("form");
      productForm.addEventListener("submit", function() {  
        setTimeout(function() { 
          priceQuantity = 1;           
        }, 100);
      });
    } else {    
      const quantitySelector = document.querySelector('input[name="quantity"]');
      if (quantitySelector && parseInt(quantitySelector.value) != window.priceQuantity) {
        quantitySelector.value = window.priceQuantity;
      }
    }
  }

  calculatePrice(quantity,priceForOne) {
    return priceForOne * quantity;
  }

  formatPrice(price) {
    let _price = price;
    _price = _price.toFixed('2').toString().replace('.',',');
    let dataFormat = this.dataFormat;
    return dataFormat.replace('11,11', price.toFixed('2').toString().replace('.',','));
  }
}

customElements.define('pdp-price-quantity', PriceQuantity);